<template>
  <div>
    <div class="Blockbox_left">
      <div class="header">
        <el-menu
          ref="elMenuRef"
          class="menu-type"
          :unique-opened="true"
          @close="menuClose"
        >
          <el-submenu
            :index="`${index}`"
            :key="item.id"
            v-for="(item, index) in headerData"
          >
            <template slot="title">
              <div @click="subHandleClick(item)">
                <span>{{ item.name }}</span>
              </div>
            </template>
            <el-menu-item
              :index="`${index}-${index2}`"
              :key="item2.id"
              v-for="(item2, index2) in item.list"
              style="color: #54667a"
              @click="handleClick(item2, index2)"
            >
              <span class="icon"></span>
              <span class="text">{{ item2 }}</span></el-menu-item
            >
          </el-submenu>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import Homseach from "@/components/pc/serch.vue";
import { GetChartData } from "@/assets/server/api";
import { timestampConvertTime1 } from "@/utils/utils.js";
const echarts = require("echarts");
export default {
  data() {
    return {
      ImgUrl: require("@/assets/pc/charts/xialax.png"),
      headerData: [
        {
          name: "Blockchan Data",
          id: 0,
          list: [
            "User Transactions",
            "Peak TPS",
            "Transaction signature total",
            "Average Gas Unit Price",
            "Daily Gas Used",
          ],
          show: true,
        },
        {
          name: "TFSC circulation",
          id: 1,
          list: [
            "User Bonus & Burned",
            "TFSC Transaction Volume",
            "TFSC Supply & Staking",
          ],
          show: false,
        },
        {
          name: "Accounts",
          id: 2,
          list: ["Total Account & Active Account", "New Accounts Created"],
          show: false,
        },
        {
          name: "Contracts",
          id: 3,
          list: [
            "Daily contract call",
            "Daily Contract Call Distribution",
            "Contract Count",
          ],
          show: false,
        },
      ],
      ind: 0,
    };
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  watch: {
    // deep: true,
    $route: {
      handler: function (to) {
        console.log(to.query);
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    Homseach,
  },
  mounted() {},
  methods: {
    chart1() {
      this.$router.push("/pc/AverageGas");
    },
    menuClose(index) {
      //保留一个菜单总保持打开状态
      if (this.$refs.elMenuRef.openedMenus.length < 1) {
        this.$refs.elMenuRef.open(index);
      }
    },
    handleClick(data, index) {
      console.log(data);
      console.log(index);
      // if (data == "User Transactions") {
      //   this.$router.push({ path: "/pc/UserTransactions" });
      // }
      //  if (data == "Peak TPS") {
      //   this.$router.push({ path: "/pc/PeakTPS" });
      // }
      // else if (data == "Transaction signature total") {
      //   this.$router.push({ path: "/pc/Transactionsignature" });
      // } else if (data == "Average Gas Unit Price") {
      //   this.$router.push({ path: "/pc/AverageGas" });
      // } else if (data == "Daily Gas Used") {
      //   this.$router.push({ path: "/pc/DailyGas" });
      // }

      this.$emit("menuHandleClick", data);
    },
    subHandleClick(data) {
      this.ind = data.id;
      this.$emit("menuHandleClick", data);
      //取消当前导航选中项
      this.$refs.elMenuRef.activeIndex = null;
    },
  },
};
</script>

<style lang="less">

.el-submenu__title {
  color: #ffffff !important;
}
.el-menu-item {
  color: #ffffff !important;
}
.el-menu {
  background: none !important;
  border: none;
  overflow: hidden;
}
.el-submenu__title i{
  color: #ffffff;
}
.el-submenu.is-opened .el-submenu__title {
  //设置一级菜单点开后的状态
  color: #00e79a !important;
  // background-color: #252f3b !important;
  // border-left: 2px solid #409eff;
}

.el-menu-item:focus,
.el-menu-item:hover,
.el-menu-item:hover i,
.el-menu .el-submenu .el-submenu__title:hover,
.el-menu .el-submenu .el-submenu__title:hover i,
.el-menu .el-submenu .el-submenu__title:focus {
  background: none;
  color: #00e79a !important;
}
.el-menu-item.is-active {
  //background: #24283c;
  color: #00e79a !important;
}
.el-menu-item.is-active::before {
  content: "";
  // position: absolute;
  // border-left: 2px solid #f4bf08;
  // height: 34px;
  // top: 5px;
  // left: 0px;
  color: #00e79a !important;
}
.el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{
  color: #00e79a !important;
}
.Blockbox_left {
  width: 268px;
  height: 238px;
  background: #0b0c0f;
  opacity: 1;
  border-radius: 16px 16px 16px 16px;
  .header {
    width: 268px;
    background-color: #0b0c0f;
    border-radius: 16px 16px 16px 16px;
    color: #ffffff;
    ul {
      width: 100%;
      li {
        width: 100%;
        text-align: left;
        cursor: pointer; // float: left;
        color: 20px;
        // padding-left: 20px;
        font-size: 18px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
        // display: flex;
        // text-align: center;
        line-height: 60px;
        .boxall {
          display: flex;
          justify-content: space-between;
          margin-right: 20px;
          .blockname {
            // width: 180px;
          }
          img {
            margin-top: 18px;
            width: 24px;
            height: 24px;
          }
        }

        &:hover {
          background-color: #0b0c0f;
          border-radius: 16px 16px 16px 16px;
        }
        ul {
          width: 100%;
          // background: red;
          li {
            font-size: 14px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
            &:hover {
              // background: #c31111;
              color: #00e79a;
            }
            .actives {
              color: #00e79a;
            }
          }
        }
      }
      .active {
        // background-color: #ff9800;
        font-size: 18px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #00e79a;
        text-align: left;
        padding-left: 20px;
      }
    }
  }
}
</style>
